/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHash = createReactComponent("outline", "hash", "IconHash", [["path", { "d": "M5 9l14 0", "key": "svg-0" }], ["path", { "d": "M5 15l14 0", "key": "svg-1" }], ["path", { "d": "M11 4l-4 16", "key": "svg-2" }], ["path", { "d": "M17 4l-4 16", "key": "svg-3" }]]);

export { IconHash as default };
//# sourceMappingURL=IconHash.mjs.map
